module.exports = __webpack_public_path__ + "img/copy.ec4723ca.svg";